import { NgModule } from '@angular/core';
import { CharterBuyflowVesselsComponent } from './charter-buyflow-vessels.component';
import { CharterBuyflowVesselsResolve } from './charter-buyflow-vessels.resolve';
import { CharterBuyflowVesselsRoutingModule } from './charter-buyflow-vessels-routing.module';
import { FullWidthBannerModule } from '../../../shared/public-components/full-width-banner/full-width-banner.module';
import { BuyflowVesselListModule } from '../../../shared/public-components/buyflow-vessel-list/buyflow-vessel-list.module';
import { BuyflowSortFilterControlModule } from '../../../shared/buyflow-sort-filter-control/buyflow-sort-filter-control.module';
import { CommonModule } from '@angular/common';
import { CarouselVesselCardModule } from '../../../shared/public-components/carousel-vessel-card/carousel-vessel-card.module';
import { AppBuflowMapModule } from '../../../shared/app-buyflow-map/app-buyflow-map.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { BuyflowNoBoatsFoundModule } from '../../buyflow-no-boats-found/buyflow-no-boats-found.module';
import { PlacesAutocompleteModule } from '../../../shared/places-autocomplete/places-autocomplete.module';
import { BuyflowSearchBarModule } from '../../buyflow-search-bar/buyflow-search-bar.module';
import { CompactBuyflowSearchBarModule } from '../../buyflow-search-bar-compact/buyflow-search-bar.module';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { SkeletonLoadModule } from '../../../shared/skeleton-load/skeleton-load.module';
import { SharedModule } from '../../../shared/shared.module';
import { ProgressSpinnerModule } from '../../../shared/progress-spinner-overlay/progress-spinner-overlay.module';
import { OrderVesselsByBuyflowVesselSortType } from '../../../shared/pipes/order-vessels-by/order-vessels-by.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaginationModule } from '../../../shared/pagination/pagination.module';
import { BuyflowMapDialogComponent } from '../../buyflow-map-dialog/buyflow-map-dialog.component';
import { BuyflowSortFilterDialogModule } from '../../buyflow-sort-filter-dialog/buyflow-sort-filter-dialog.module';
import { InfiniteScrollModule } from '../../../shared/directives/infinite-scroll/infinite-scroll.module';

@NgModule({
  imports: [
    CharterBuyflowVesselsRoutingModule,
    FullWidthBannerModule,
    BuyflowVesselListModule,
    BuyflowSortFilterControlModule,
    CommonModule,
    CarouselVesselCardModule,
    AppBuflowMapModule,
    MatDatepickerModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    BuyflowNoBoatsFoundModule,
    PlacesAutocompleteModule,
    BuyflowSearchBarModule,
    LoadingModule,
    CompactBuyflowSearchBarModule,
    SkeletonLoadModule,
    SharedModule,
    ProgressSpinnerModule,
    BuyflowNoBoatsFoundModule,
    GoogleMapsModule,
    PaginationModule,
    BuyflowSortFilterDialogModule,
    InfiniteScrollModule,
  ],
  declarations: [CharterBuyflowVesselsComponent, BuyflowMapDialogComponent],
  entryComponents: [CharterBuyflowVesselsComponent],
  exports: [CharterBuyflowVesselsComponent],
  providers: [
    CharterBuyflowVesselsResolve,
    OrderVesselsByBuyflowVesselSortType,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class CharterBuyflowVesselsModule {}
